import { FC } from "react";
import classNames from "classnames";

import { OverviewRankingItem, OverviewRankingListProps } from "./types";
import { getValueVariant } from "./utils/getValueVariant";
import Skeleton from "../Skeleton/Skeleton";
import LogoBrand from "../LogoBrand/LogoBrand";

import styles from "./OverviewRankingList.module.css";



const EMPTY_MESSAGE = "No data for the selected period";

export const OverviewRankingList: FC<OverviewRankingListProps> = ({
  className,
  items,
  isLoading = false,
}) => {
  const renderItems = function(listItems: OverviewRankingItem[] | null) {
    const showRankingSkeleton =
      isLoading && (listItems == null || listItems.length === 0);

    if (showRankingSkeleton) {
      return Array(5)
        .fill(null)
        .map((_, index) => (
          <li key={index} className={styles["overview-ranking-list__item"]}>
            <Skeleton height={32} variant="text" />
          </li>
        ));
    }

    if (!isLoading && (!listItems || listItems.length === 0)) {
      return (
        <li className={styles["overview-ranking-list__empty"]}>
          <p>{EMPTY_MESSAGE}</p>
        </li>
      );
    }

    return (listItems ?? []).map((item, index) => (
      <li key={item.id} className={styles["overview-ranking-list__item"]}>
        <div className={styles["overview-ranking-list__logo"]}>
          <LogoBrand name={item.name} logoUrl={item.logoUrl} />
        </div>

        <div className={styles["overview-ranking-list__name"]}>
          {item.name}
        </div>

        {item.value ? (
          <span
            className={classNames(
              styles["overview-ranking-list__value"],
              styles[getValueVariant(index + 1)]
            )}
          >
            {item.value}
          </span>
        ) : null}
      </li>
    ));
  };

  return (
    <div className={classNames(styles["overview-ranking-list"], className)}>
      <ul className={styles["overview-ranking-list__list"]}>
        {renderItems(items)}
      </ul>
    </div>
  );
};

